import styled from 'styled-components';
import { ADMIN_TEXT_TITLE_FIELD_ERROR } from 'style/mixins';

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  ${ADMIN_TEXT_TITLE_FIELD_ERROR};
`;